import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    // CHARTS
    "ProcessesStatusByFarmYear": {
        meta: {
            i18nDescrKey: "processes-stauts-by-farm-year",
            filters: ["s-c-leader-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./charts/ProcessesStatusByFarmYear.vue")
    },

    "process-list-tile": () => import("./tiles/ProcessListTile.vue"),
    "inspection-list-tile": () => import("./tiles/ProcessInspectionListTile.vue"),
    "process-detail-tile": () => import("./tiles/ProcessDetailTile.vue"),
    "process-new-tile": () => import("./tiles/ProcessNewTile.vue"),
    "SingleTileContainer": () => import("./components/SingleTileContainer.vue"),

    "ProcessYearsSelectNavbarItem": () => import("./components/navbar/ProcessYearsSelectNavbarItem.vue"),

    "OldProcessesIframeTile": () => import("./tiles/OldProcessesIframeTile.vue")
};

export default globals;
